import React from "react";

import styled from "@emotion/styled";

import { ErrorMessageP } from "../FormError";

export const ErrorWrapper = styled.div`
    font-size: small;
    color: ${({ theme }) => theme.colors.red.toString()};
`;

interface iErrorMessage {
    error: any;
    name: string;
    rules: any;
}

const ErrorMessage = ({ error, name, rules }: iErrorMessage) => {
    const getMessage = (type: string): string => {
        if (error.message) {
            return error.message;
        }

        if (
            rules.maxLength &&
            rules.minLength &&
            rules.maxLength === rules.minLength &&
            (type === "maxLength" || type === "minLength")
        ) {
            return `${name} sollte exakt ${rules.maxLength} Zeichen haben.`;
        }

        if (name === "App ID*" && rules.required && type === "required") {
            return `Bitte wähle eine App ID aus.`;
        }

        const messages: { [key: string]: string } = {
            required: `${name} muss ausgefüllt werden.`,
            maxLength: `${name} darf maximal ${rules.maxLength} Zeichen lang sein.`,
            minLength: `${name} muss minimal ${rules.minLength} Zeichen lang sein.`,
        };

        if (messages[type]) {
            return messages[type];
        }

        return "Fehler";
    };

    return (
        <>{error && <ErrorMessageP>{getMessage(error.type)}</ErrorMessageP>}</>
    );
};

export default ErrorMessage;
